import API from "../../../utils/api";

export const getStockUpdateIntervalsApi = async (filters) => {
  const response = await API.get("settings/stock-update-interval", { params: filters });
  return { response };
};

export const addStockUpdateIntervalsApi = async (data) => {
  const response = await API.post("settings/stock-update-interval", data);
  return { response };
};

export const updateStockUpdateIntervalsApi = async (data, id) => {
  const response = await API.put(`settings/stock-update-interval/${id}`, data);
  return { response };
};

export const deleteStockUpdateIntervalsApi = async (id) => {
  const response = await API.delete(`settings/stock-update-interval/${id}`);
  return { response };
};
